module.exports = __webpack_public_path__ + "media/plucky.a90b8d5c.mp3";